import * as yup from 'yup';
import { firstValueFrom } from 'rxjs';
import { CustomerNumber, customerService } from '../../../../services/customer.service';
import { responseHandler } from '../../../../../../shared/responseHandler/responseHandler';
import { C_E_Invoice_Format } from '../../../../../../graphql/generatedModel';

export const createValidationSchema = (): yup.AnyObjectSchema => {
  const schema = yup
    .object({
      bank1MandatNo: yup
        .string()
        .nullable()
        .test(
          'bank1MandatNo-server-validation',
          'article.not_unique_number',
          async (value, { parent, options: { context } }): Promise<any> => {
            if (context?.prevBank1MandatNo.current === value) {
              return true;
            }
            try {
              customerService.pub.validateCustomerFields({
                context: { setLoading: context?.setBank1MandatLoading },
                fieldsForCheck: { bank1MandatNo: value },
                id: parent.id,
              });

              const result = await firstValueFrom(
                customerService.sub
                  .validateBank1MandatNo()
                  .pipe(responseHandler<CustomerNumber>({ errorReturnType: undefined })),
              );
              switch (result) {
                case CustomerNumber.valid:
                  return true;
                case CustomerNumber.invalid:
                  return false;
                default:
                  return false;
              }
            } catch (error) {
              if (error instanceof Error) {
                throw new Error(`Server validation failed: ${error.message}`);
              }
              throw new Error('An unknown error occurred during server validation');
            } finally {
              context!.prevBank1MandatNo.current = value;
            }
          },
        ),
      bank2MandatNo: yup
        .string()
        .nullable()
        .test(
          'bank2MandatNo-server-validation',
          'article.not_unique_number',
          async (value, { parent, options: { context } }): Promise<any> => {
            if (context?.prevBank2MandatNo.current === value) {
              return true;
            }
            try {
              customerService.pub.validateCustomerFields({
                context: { setLoading: context?.setBank2MandatLoading },
                fieldsForCheck: { bank2MandatNo: value },
                id: parent.id,
              });

              const result = await firstValueFrom(
                customerService.sub
                  .validateBank2MandatNo()
                  .pipe(responseHandler<CustomerNumber>({ errorReturnType: undefined })),
              );
              switch (result) {
                case CustomerNumber.valid:
                  return true;
                case CustomerNumber.invalid:
                  return false;
                default:
                  return false;
              }
            } catch (error) {
              if (error instanceof Error) {
                throw new Error(`Server validation failed: ${error.message}`);
              }
              throw new Error('An unknown error occurred during server validation');
            } finally {
              context!.prevBank2MandatNo.current = value;
            }
          },
        ),
      eInvoiceRoutingAddress: yup.string().when('eInvoiceFormat', ([eInvoiceFormat], schema) => {
        return eInvoiceFormat === C_E_Invoice_Format.EIF1_PDF_XML_XRECHNUNG_PROFILE ||
          eInvoiceFormat === C_E_Invoice_Format.EIF2_XML_XRECHNUNG_PROFILE
          ? schema.required('common.not_empty')
          : schema.nullable();
      }),
    })
    .shape({});
  return schema;
};
